import { render } from "./BlogPlaceholder.vue?vue&type=template&id=4e4829e5&scoped=true"
import script from "./BlogPlaceholder.vue?vue&type=script&lang=js"
export * from "./BlogPlaceholder.vue?vue&type=script&lang=js"

import "./BlogPlaceholder.vue?vue&type=style&index=0&id=4e4829e5&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Jerald Pamugas\\OneDrive\\Desktop\\Projects\\jerald-pamugas-1\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e4829e5"]])

export default __exports__